module.exports = "../dist/img/product-detail-1-.ed76.jpg";